module.exports = __webpack_public_path__ + "static/media/reddit_etl.90ff53c1.png";